// Recovered compiled webpack factory 41416. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { w: () => s });
  var n = r(27122),
    a = r(80266);
  function s(e, t) {
    let r = e instanceof a.d,
      s = r ? e.browserReason : void 0,
      i = s
        ? /caused context loss and was blocked/i.test(s)
          ? "site_blocked"
          : /not allowed to create a webgl context/i.test(s)
            ? "not_allowed"
            : "unavailable"
        : "unavailable";
    return (
      n.Cp(e, {
        level: r && "site_blocked" !== i ? "warning" : "error",
        fingerprint: r ? ["webgl-init-failed", t, i] : void 0,
        tags: { webgl: "init_failed", "webgl.init_failure": i, "webgl.surface": t },
        extra: {
          browserReason: s ?? null,
          userAgent: "undefined" != typeof navigator ? navigator.userAgent : "unknown",
        },
      }),
      i
    );
  }
}
